(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/constants.js');
"use strict";


const WIDGET_ID = {
  enetpulseH2H: 'enetpulse-h2h-widget',
  enetpulseTable: 'enetpulse-table-widget',
  impleoWidget: 'impleo-widget',
  tooltipWidget: 'tooltip-widget',
  sokWidget: 'sok-widget',
  playmakerWidget: 'playmaker-widget',
  trajectoryWidget: 'trajectory-widget',
  walletWidget: 'wallet-widget'
};
const WIDGET_TAG = {
  enetpulseH2H: 'enetpulse-h2h-gameinformation',
  enetpulseTable: 'enetpulse-table-gameinformation',
  impleoWidget: 'impleo-gameinformation',
  tooltipWidget: 'tooltip-widget',
  sokWidget: 'sok-widget',
  playmakerWidget: 'playmaker-widget',
  trajectoryWidget: 'event-component',
  walletWidget: 'wallet-widget'
};
const WIDGET_CONDITIONS = {
  mobile: {
    devices: ['mobile']
  },
  desktop: {
    devices: ['desktop']
  }
};
const exported = {
  WIDGET_ID,
  WIDGET_TAG,
  WIDGET_CONDITIONS
};
if (svs.isServer) {
  module.exports = exported;
} else {
  setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.constants', exported);
}

 })(window);